import { render, staticRenderFns } from "./CogView.vue?vue&type=template&id=427f37e0&scoped=true"
import script from "./CogView.vue?vue&type=script&lang=js"
export * from "./CogView.vue?vue&type=script&lang=js"
import style0 from "./CogView.vue?vue&type=style&index=0&id=427f37e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427f37e0",
  null
  
)

export default component.exports